import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GoogleBusinessProfileFirstConnectionComponent } from './google-business-profile-first-connection/google-business-profile-first-connection.component';
import { GoogleBusinessProfileLocationsComponent } from './google-business-profile-locations/google-business-profile-locations.component';
import { GoogleBusinessProfileLoginComponent } from './google-business-profile-login/google-business-profile-login.component';

@NgModule({
  declarations: [
    GoogleBusinessProfileLocationsComponent,
    GoogleBusinessProfileFirstConnectionComponent,
    GoogleBusinessProfileLoginComponent,
  ],
  imports: [SharedModule, CommonModule],
})
export class GoogleBusinessProfileModule {}
